import React from 'react';
import PropTypes from 'prop-types';

export const EmptyBalance = ({ width, height, ...props }) => (
  <svg
    data-icon='empty-balance'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 66 71'
    { ...props }
  >
    <path
      fill='#FAFAFA'
      d='M33 70.688c18.225 0 33-14.775 33-33s-14.775-33-33-33-33 14.775-33 33 14.775 33 33 33Z'
    />
    <g filter='url(#a)'>
      <path
        fill='#fff'
        d='M51.919 3.608h-37.84c-1.215 0-2.2 1.051-2.2 2.348V55.26c0 1.297.985 2.348 2.2 2.348h37.84c1.215 0 2.2-1.051 2.2-2.348V5.956c0-1.297-.985-2.348-2.2-2.348Z'
      />
    </g>
    <path
      fill='#FFD89D'
      d='M28.6 10.208H17.16a1.32 1.32 0 0 0 0 2.64H28.6a1.32 1.32 0 1 0 0-2.64Z'
    />
    <path
      fill='#EEE'
      d='M41.38 15.608H17.62c-.895 0-1.62.672-1.62 1.5s.725 1.5 1.62 1.5h23.76c.895 0 1.62-.672 1.62-1.5s-.725-1.5-1.62-1.5Z'
    />
    <path
      fill='#FFD89D'
      d='M28.6 22.088H17.16a1.32 1.32 0 0 0 0 2.64H28.6a1.32 1.32 0 1 0 0-2.64Z'
    />
    <path
      fill='#EEE'
      d='M33.86 27.608H17.14c-.63 0-1.14.672-1.14 1.5s.51 1.5 1.14 1.5h16.72c.63 0 1.14-.672 1.14-1.5s-.51-1.5-1.14-1.5Z'
    />
    <path
      fill='#FFD89D'
      d='M28.6 45.608H17.16a1.32 1.32 0 0 0 0 2.64H28.6a1.32 1.32 0 1 0 0-2.64Z'
    />
    <path
      fill='#EEE'
      d='M47.02 51.608H17.98c-1.093 0-1.98.672-1.98 1.5 0 .829.887 1.5 1.98 1.5h29.04c1.093 0 1.98-.671 1.98-1.5 0-.828-.886-1.5-1.98-1.5Z'
    />
    <path
      fill='#FFD89D'
      d='M28.6 33.968H17.16a1.32 1.32 0 0 0 0 2.64H28.6a1.32 1.32 0 1 0 0-2.64Z'
    />
    <path
      fill='#EEE'
      d='M41.38 39.608H17.62c-.895 0-1.62.672-1.62 1.5 0 .829.725 1.5 1.62 1.5h23.76c.895 0 1.62-.671 1.62-1.5 0-.828-.725-1.5-1.62-1.5Z'
    />
    <defs>
      <filter
        id='a'
        width={ 56.327 }
        height={ 68.089 }
        x={ 4.835 }
        y={ 0 }
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'
      >
        <feFlood
          floodOpacity={ 0 }
          result='BackgroundImageFix'
        />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dy={ 3.436 } />
        <feGaussianBlur
          stdDeviation={ 3.522 }
        />
        <feColorMatrix values='0 0 0 0 0.129412 0 0 0 0 0.129412 0 0 0 0 0.129412 0 0 0 0.05 0' />
        <feBlend
          in2='BackgroundImageFix'
          result='effect1_dropShadow_7273_339791'
        />
        <feBlend
          in='SourceGraphic'
          in2='effect1_dropShadow_7273_339791'
          result='shape'
        />
      </filter>
    </defs>
  </svg>
);

EmptyBalance.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

EmptyBalance.defaultProps = {
  width: 66,
  height: 66,
};
